.stepIcon {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  min-height: 28px !important;
  flex: 0 0 28px;
  padding: 0;
  border-radius: 50%;
  box-sizing: border-box;
  background-color: transparent;
  color: light-dark(var(--mantine-color-secondary-6), var(--mantine-color-secondary-0));
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stepIcon[data-progress] {
  background-color: var(--mantine-color-primary-7);
  color: #fff;
  border: none !important;
  box-shadow: none !important;
}

.stepIcon[data-completed] {
  background-color: var(--mantine-color-primary-7);
  border: none !important;
  color: #fff;
}

.stepIcon[data-completed] svg {
  width: 12px !important;
  height: 12px !important;
}

.stepBody {
  margin-left: 0.5em;
}

.separator {
  background-color: light-dark(#d0d5dd, #646464);
}

.separator[data-active] {
  background-color: var(--mantine-color-primary-7);
}

.step {
  cursor: default;
}

.step[data-progress],
.step[data-completed] {
  cursor: pointer;
}

.step[data-progress] .stepIcon,
.step[data-progress] .stepBody,
.step[data-completed] .stepIcon,
.step[data-completed] .stepBody {
  cursor: pointer;
}

.step[data-disabled] {
  cursor: not-allowed;
}

.step[data-disabled] .stepIcon,
.step[data-disabled] .stepBody {
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .stepIcon {
    width: 16px !important;
    height: 16px !important;
    min-width: 16px !important;
    min-height: 16px !important;
    flex-basis: 16px;
    font-size: 11px;
  }

  .stepIcon[data-completed] svg {
    width: 10px !important;
    height: 10px !important;
  }

  .stepBody {
    margin-left: 0.35em;
  }

  .stepLabel {
    font-size: 14px !important;
  }
}
